// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* tslint:disable */
/* eslint-disable */
import "../textstyles/fonts.css";
import "../reset.css";
import "./EventPickupWindows.PickupWindowContainer.css";
import React, { createContext, useContext } from "react";
import {
  findSetVariantProps,
  makeCompositeDefaultProps,
} from "../_internal_utils";
import {
  RootPrimitive,
  SpacerPrimitive,
  TextPrimitive,
  ContainerPrimitive,
} from "../_internal_primitives";

const styles = [
  {
    type: "default",
    layers: {
      "28bqfKddvK": {
        none: {
          text:
            "Add Pickup Windows to give customers a range of times to place their orders.",
        },
      },
      Hh8CgGeoBq: {
        none: {
          text: "Pickup Windows",
        },
      },
    },
  },
  {
    type: "boolean",
    propName: "isEmpty",
    layers: {},
  },
];

const defaultPropValues = [
  {
    type: "default",
    layers: {},
  },
  {
    type: "boolean",
    propName: "isEmpty",
    layers: {},
  },
];

const variantPropTypes = [
  {
    type: "boolean",
    propName: "isEmpty",
  },
];

export const PickupWindowContainerContext = createContext(null);

function PickupWindowContainer(_props) {
  const defaults = useContext(PickupWindowContainerContext);
  const props = { ...defaults, ..._props };
  const activeVariants = findSetVariantProps(variantPropTypes, props);
  const getCompositeDefaultProps = makeCompositeDefaultProps(
    defaultPropValues,
    activeVariants
  );
  return (
    <RootPrimitive
      {...props}
      key="5yx7hiYR9b"
      addSpacing={false}
      internal={{
        projectId: "7X7HTLRqyD",
        styles: styles,
        layerId: "5yx7hiYR9b",
        scope: "SA3rEqje3W",
        activeVariants: activeVariants,
      }}
    >
      {(getStyle) => (
        <>
          <TextPrimitive
            id={"Text_28bqfKddvK"}
            className={
              "__visly_reset_7X7HTLRqyD __visly_scope_SA3rEqje3W_28bqfKddvK"
            }
            key={"28bqfKddvK"}
            text={getStyle("28bqfKddvK", "text")}
            element={getStyle("28bqfKddvK", "htmlElement")}
          />
          <TextPrimitive
            id={"Text_Hh8CgGeoBq"}
            className={
              "__visly_reset_7X7HTLRqyD __visly_scope_SA3rEqje3W_Hh8CgGeoBq"
            }
            key={"Hh8CgGeoBq"}
            text={getStyle("Hh8CgGeoBq", "text")}
            element={getStyle("Hh8CgGeoBq", "htmlElement")}
          />
          <SpacerPrimitive
            id={"Spacer_Hdhp5GYf86"}
            className={
              "__visly_reset_7X7HTLRqyD __visly_scope_SA3rEqje3W_Hdhp5GYf86"
            }
            key={"Hdhp5GYf86"}
          />
          <ContainerPrimitive
            key={"KyH3eU5JqC"}
            id={"Slot_KyH3eU5JqC"}
            className={
              "__visly_reset_7X7HTLRqyD __visly_scope_SA3rEqje3W_KyH3eU5JqC"
            }
            addSpacing={true}
          >
            {props.children}
          </ContainerPrimitive>
        </>
      )}
    </RootPrimitive>
  );
}

PickupWindowContainer.__variants = [
  {
    name: "isEmpty",
    type: "variant",
  },
];

export default PickupWindowContainer;
